import React from 'react';

const ArrowUpSorting: React.FC<React.PropsWithChildren> = () => (
  <svg width="20" height="20" viewBox="0 0 28 28" fill="#FFF">
    <path d="M0 7L1.41 8.41L6 3.83V20H8V3.83L12.59 8.42L14 7L7 0L0 7Z" fill="#FFF" />
  </svg>
);

export default ArrowUpSorting;
